import styled from "@emotion/styled";
import myThemes from "../../common/themes/Themes";
export const StyledAppointmentCard = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  backgroundColor: myThemes[theme].palette.primary,
  borderRadius: "15px",
  minHeight: "80px",
  fontFamily: "Inter",
  padding: "13px",
  marginBottom: "10px",
  maxWidth: "400px",
  minWidth: "180px",
  color: myThemes[theme].palette.quarternary,
}));

export const AppointmentActionButton = styled("div")((theme) => ({
  backgroundColor: myThemes[theme].palette.secondary,
  fontFamily: "Inter",
  display: "inline",
  fontWeight: "600",
  fontSize: "0.8rem",
  borderRadius: "30px",
  paddingLeft: "10px",
  paddingRight: "10px",
  paddingTop: "4px",
  paddingBottom: "4px",
  color: myThemes[theme].palette.quarternary,
}));
